import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";
import { AddItemInput, ItemSummaryDocument } from "~/gql/graphqlBase.generated";

interface ItemsState {
	addItemInput: AddItemInput | undefined;
	itemFormOpen: boolean;
	ruleFormOpen: boolean;
	selectedItem: ItemSummaryDocument | null;
	viewType: ViewType;
}

const initialState: ItemsState = {
	addItemInput: undefined,
	itemFormOpen: false,
	ruleFormOpen: false,
	selectedItem: null,
	viewType: "card"
};

const itemsSlice = createSlice({
	initialState,
	name: "restockItems",
	reducers: {
		closeItemForm: (state) => {
			state.itemFormOpen = false;
		},
		closeRuleForm: (state) => {
			state.ruleFormOpen = false;
		},
		openItemForm: (state) => {
			state.itemFormOpen = true;
		},
		openRuleForm: (state) => {
			state.ruleFormOpen = true;
		},
		setAddItemInput: (state, action: PayloadAction<AddItemInput | null>) => {
			if (action.payload === null) {
				state.addItemInput = undefined;
				return;
			}
			state.addItemInput = { ...action.payload };
		},
		setSelectedItem: (state, action: PayloadAction<ItemSummaryDocument | null>) => {
			state.selectedItem = action.payload;
		},
		setViewType: (state, action: PayloadAction<ViewType>) => {
			state.viewType = action.payload;
		}
	}
});

export const {
	closeItemForm,
	closeRuleForm,
	openItemForm,
	openRuleForm,
	setAddItemInput,
	setSelectedItem,
	setViewType
} = itemsSlice.actions;

export default itemsSlice.reducer;
